import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { CustomerSimpleView } from '../../../Customer/components'
import { useGetRoleCustomer } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function RoleCustomer(props) {
  const { role } = props

  // [ADDITIONAL_HOOKS]
  const [customer, loading] = useGetRoleCustomer(role)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : customer ? (
            <CustomerSimpleView {...props} customer={customer} />
          ) : (
            <Text type="secondary" variant="overline">
              {t('No customers have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

RoleCustomer.propTypes = {
  role: PropTypes.object.isRequired
}
